import type { Infer } from 'superstruct';
import { array, boolean, number, object, optional, string } from 'superstruct';

import {
	isoDateTimeWithCoercions,
	parsableInteger,
} from '@adflow/shared/util-superstruct';

import { DataTableItemType } from './data-table-item-type';

export const ViewColumnTemplateColumnDto = object({
	id: string(),
	visible: optional(boolean()),
	sticky: optional(boolean()),
	widthConfig: optional(number()),
	disableOrdering: optional(boolean()),
});

export type ViewColumnTemplateColumnDto = Infer<
	typeof ViewColumnTemplateColumnDto
>;

export const ViewColumnTemplateDto = object({
	id: parsableInteger(),
	columnType: DataTableItemType,
	columns: array(ViewColumnTemplateColumnDto),
	createdAt: isoDateTimeWithCoercions(),
	updatedAt: isoDateTimeWithCoercions(),
	name: string(),
	savedAll: boolean(),
	savedDefault: optional(boolean()),
});

export type ViewColumnTemplateDto = Infer<typeof ViewColumnTemplateDto>;
